import { z } from "zod";

export const placementSchema = z.object({
	x: z.number(),
	y: z.number(),
});
